import { __awaiter, __generator } from "tslib";
export var CallReportingStatus;
(function (CallReportingStatus) {
    CallReportingStatus["Abandoned"] = "abandoned";
    CallReportingStatus["Cancel"] = "cancel";
    CallReportingStatus["Success"] = "success";
    CallReportingStatus["Failed"] = "failed";
    CallReportingStatus["Missed"] = "missed";
    CallReportingStatus["Timeout"] = "timeout";
    CallReportingStatus["Endless"] = "endless";
    CallReportingStatus["Transferred"] = "transferred";
})(CallReportingStatus || (CallReportingStatus = {}));
export var EavesdropState;
(function (EavesdropState) {
    EavesdropState["Muted"] = "muted";
    EavesdropState["Conference"] = "conference";
    EavesdropState["Prompt"] = "prompt";
})(EavesdropState || (EavesdropState = {}));
export var EavesdropType;
(function (EavesdropType) {
    EavesdropType["Joined"] = "joined";
    EavesdropType["Leave"] = "leave";
    EavesdropType["Hide"] = "hide";
})(EavesdropType || (EavesdropType = {}));
export var CallActions;
(function (CallActions) {
    CallActions["Ringing"] = "ringing";
    CallActions["Active"] = "active";
    CallActions["Bridge"] = "bridge";
    CallActions["Hold"] = "hold";
    CallActions["DTMF"] = "dtmf";
    CallActions["Voice"] = "voice";
    CallActions["Silence"] = "silence";
    CallActions["Execute"] = "execute";
    CallActions["Update"] = "update";
    CallActions["Hangup"] = "hangup";
    CallActions["Reporting"] = "reporting";
    CallActions["PeerStream"] = "peerStream";
    CallActions["LocalStream"] = "localStream";
    CallActions["Destroy"] = "destroy";
    CallActions["Eavesdrop"] = "eavesdrop";
})(CallActions || (CallActions = {}));
export var CallDirection;
(function (CallDirection) {
    CallDirection["Inbound"] = "inbound";
    CallDirection["Outbound"] = "outbound";
})(CallDirection || (CallDirection = {}));
var Call = /** @class */ (function () {
    function Call(client, e) {
        this.client = client;
        // FIXME check _muted from channel
        var callInfo = e.data;
        this._muted = false;
        this.voice = true;
        this.createdAt = +e.timestamp;
        this.task = null;
        this.data = null;
        this._eavesdrop = null;
        this._autoAnswerTimerId = null;
        this._activeCounter = 0;
        this.answeredAt = 0;
        this.hangupAt = 0;
        this.bridgedAt = 0;
        this.reportingAt = 0;
        this.autoAnswered = false;
        this.peerStreams = [];
        this.localStreams = [];
        if (callInfo.eavesdrop) {
            this._eavesdrop = callInfo.eavesdrop;
        }
        // fixme
        if (client.phone) {
            if (callInfo.sip_id) {
                this.setSip(client.phone.sipSessionBySipId(callInfo.sip_id));
            }
            else {
                this.setSip(client.phone.sipSessionByCallId(e.id));
            }
        }
        this.params = {};
        this.id = e.id;
        this.digits = [];
        this.applications = [];
        this.appId = e.app_id;
        this.setState(e);
        this.setInfo(callInfo);
        if (this.queue && this.client.agent) {
            this.task = this.client.agent.task.get(+this.queue.attempt_id) || null;
        }
    }
    // set private
    Call.prototype.setState = function (s) {
        this.state = s.event;
    };
    Call.prototype.setSip = function (sip) {
        if (sip && !this.sip) {
            this.sip = sip;
            this.localStreams = sip.getLocalMedia();
            this.peerStreams = sip.getPeerMedia();
        }
    };
    Object.defineProperty(Call.prototype, "duration", {
        get: function () {
            if (this.hangupAt === 0) {
                return Math.round((Date.now() - this.createdAt) / 1000); // tslint:disable-line
            }
            else {
                return Math.round((this.hangupAt - this.createdAt) / 1000); // tslint:disable-line
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowDtmf", {
        get: function () {
            return this.answeredAt > 0 && this.allowHangup;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowHangup", {
        get: function () {
            return this.hangupAt === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowHold", {
        get: function () {
            return (this.hangupAt === 0 &&
                (this.state === 'active' || this.state === 'bridge'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowAnswer", {
        get: function () {
            return (this.client.phone &&
                this.hangupAt === 0 &&
                this.answeredAt === 0 &&
                (this.queue ||
                    this.direction === CallDirection.Inbound ||
                    (this.params && !this.params.autoAnswer)));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowUnHold", {
        get: function () {
            return this.hangupAt === 0 && this.state === 'hold';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "memberCommunication", {
        get: function () {
            if (!this.task) {
                return null;
            }
            else {
                return this.task.communication;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "isEavesdrop", {
        get: function () {
            return !!this._eavesdrop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropName", {
        get: function () {
            return this.isEavesdrop ? this._eavesdrop.name : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropNumber", {
        get: function () {
            return this.isEavesdrop ? this._eavesdrop.number : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropDuration", {
        get: function () {
            return this.isEavesdrop ? this._eavesdrop.duration : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropState", {
        get: function () {
            return this.isEavesdrop ? this._eavesdrop.state : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropIsMuted", {
        get: function () {
            return this.eavesdropState === EavesdropState.Muted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropIsConference", {
        get: function () {
            return this.eavesdropState === EavesdropState.Conference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "eavesdropIsPrompt", {
        get: function () {
            return this.eavesdropState === EavesdropState.Prompt;
        },
        enumerable: false,
        configurable: true
    });
    // todo
    Call.prototype.getMember = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isMember) {
                    throw new Error("call is not from outbound queue");
                }
                return [2 /*return*/, this.client.request("cc_member_page", {
                        queue_id: this.task.queueId,
                        member_id: this.task.memberId,
                    })];
            });
        });
    };
    Object.defineProperty(Call.prototype, "isMember", {
        get: function () {
            return !!(this.task && this.task.isMember);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "firstActive", {
        get: function () {
            return this._activeCounter === 1;
        },
        enumerable: false,
        configurable: true
    });
    Call.prototype.setActive = function (e) {
        this._activeCounter++;
        if (this._autoAnswerTimerId) {
            clearTimeout(this._autoAnswerTimerId);
            this._autoAnswerTimerId = null;
        }
        if (!this.answeredAt) {
            if (this.direction === CallDirection.Inbound) {
                this.bridgedAt = +e.timestamp;
                if (this.parentId) {
                    this.bridgedId = this.parentId;
                }
            }
            this.answeredAt = +e.timestamp;
        }
        this.setState(e);
    };
    Call.prototype.setBridged = function (s) {
        var bridged = s.data;
        if (!this.bridgedAt) {
            this.bridgedAt = +s.timestamp;
        }
        this.bridgedId = bridged.bridged_id;
        if (bridged.to) {
            if (this.direction === CallDirection.Inbound) {
                this.from = bridged.to;
            }
            else {
                this.to = bridged.to;
            }
        }
        this.bridgedId = bridged.bridged_id;
        if (bridged.payload) {
            this.variables = bridged.payload;
        }
        if (bridged.queue) {
            this.queue = bridged.queue;
        }
    };
    Call.prototype.setHold = function (e) {
        this.setState(e);
    };
    Call.prototype.setInfo = function (s) {
        this.parentId = s.parent_id;
        this.destination = s.destination;
        this.direction = s.direction;
        this.from = s.from;
        this.to = s.to;
        this.variables = s.payload;
        this.queue = s.queue || null;
        this.sipId = s.sip_id || null;
        this.params = s.params;
    };
    Call.prototype.setPeerStreams = function (streams) {
        if (!streams) {
            this.peerStreams = [];
        }
        else {
            this.peerStreams = streams;
        }
    };
    Call.prototype.setLocalStreams = function (streams) {
        if (!streams) {
            this.localStreams = [];
        }
        else {
            this.localStreams = streams;
        }
    };
    Call.prototype.setVoice = function () {
        this.voice = true;
    };
    Call.prototype.setSilence = function () {
        this.voice = false;
    };
    Call.prototype.setExecute = function (s) {
        this.applications.push(s.application);
    };
    Call.prototype.addDigit = function (s) {
        this.digits.push(s.digit);
    };
    Call.prototype.setEavesdropState = function (e) {
        if (e.type === EavesdropType.Joined) {
            this._eavesdrop = e;
        }
        else if (e.type === EavesdropType.Leave) {
            this._eavesdrop = null;
        }
        else {
            this._eavesdrop.state = e.state;
        }
    };
    Call.prototype.setHangup = function (s) {
        var hangup = s.data;
        this.hangupAt = +s.timestamp;
        this.hangupCause = hangup.cause;
        this.hangupSipCode = hangup.sip;
        this.voice = false;
        this.peerStreams = [];
        if (+hangup.reporting_at) {
            this.reportingAt = +hangup.reporting_at; // FIXME type number
        }
        this.setState(s);
    };
    Object.defineProperty(Call.prototype, "allowReporting", {
        get: function () {
            return this.answeredAt > 0 && this.hasReporting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "hasReporting", {
        get: function () {
            if (this.task) {
                return this.task.hasReporting;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "display", {
        get: function () {
            return this.displayNumber + " (" + this.displayName + ")";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "muted", {
        get: function () {
            return this._muted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "isHold", {
        get: function () {
            return this.state === CallActions.Hold;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowInboundVideo", {
        get: function () {
            if (this.params) {
                return this.params.video || false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "allowOutboundVideo", {
        get: function () {
            if (this.params) {
                return this.params.video || false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "active", {
        get: function () {
            return this.hangupAt === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "displayNumber", {
        get: function () {
            if (this.direction === 'inbound') {
                return this.from.number;
            }
            else {
                if (this.to) {
                    return this.to.number;
                }
                return this.destination;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "displayName", {
        get: function () {
            if (this.direction === 'inbound') {
                return this.from.name;
            }
            else {
                if (this.to) {
                    return this.to.name;
                }
                return this.destination;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "autoAnswer", {
        get: function () {
            return ((this.queue && this.queue.queue_type === 'offline') ||
                this.autoAnswerDelay > 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "autoAnswerDelay", {
        get: function () {
            if (!this.params ||
                !this.params.autoAnswer ||
                "" + this.params.autoAnswer === 'false') {
                return 0;
            }
            else if (isFinite(+this.params.autoAnswer)) {
                return +this.params.autoAnswer;
            }
            return this.client.autoAnswerDelayTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "attempt", {
        // todo task is deprecated
        get: function () {
            return this.task;
        },
        enumerable: false,
        configurable: true
    });
    /* Call control */
    Call.prototype.answer = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var params, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.sip && this.client.phone)) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.client.phone.callOption(req)];
                    case 2:
                        params = _a.sent();
                        return [4 /*yield*/, this.sip.answer(params)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.client.handleError(e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, true];
                    case 6: return [2 /*return*/, false];
                }
            });
        });
    };
    Call.prototype.answerDelay = function (req) {
        var _this = this;
        if (this.autoAnswered) {
            return;
        }
        this._autoAnswerTimerId = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.autoAnswered) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.answer(req)];
                    case 1:
                        _a.autoAnswered = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, this.autoAnswerDelay);
    };
    Call.prototype.hangup = function (cause) {
        return __awaiter(this, void 0, void 0, function () {
            var _cause;
            return __generator(this, function (_a) {
                _cause = cause;
                if (this.answeredAt === 0 && !cause) {
                    _cause =
                        this.direction === CallDirection.Inbound
                            ? 'USER_BUSY'
                            : 'ORIGINATOR_CANCEL';
                }
                return [2 /*return*/, this.client.request('call_hangup', {
                        id: this.id,
                        app_id: this.appId,
                        cause: _cause,
                    })];
            });
        });
    };
    Call.prototype.eavesdrop = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                req.id = this.id;
                return [2 /*return*/, this.client.request('call_eavesdrop', req)];
            });
        });
    };
    Call.prototype.changeEavesdropState = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isEavesdrop) {
                    throw new Error("this call not in eavesdrop");
                }
                if (this.eavesdropState === state) {
                    throw new Error("this call already eavesdrop state: " + state);
                }
                return [2 /*return*/, this.client.request('call_eavesdrop_state', {
                        id: this.id,
                        state: state,
                    })];
            });
        });
    };
    Call.prototype.toggleHold = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.state === CallActions.Hold) {
                    return [2 /*return*/, this.unHold()];
                }
                else {
                    return [2 /*return*/, this.hold()];
                }
                return [2 /*return*/];
            });
        });
    };
    Call.prototype.hold = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.state === CallActions.Hold) {
                    throw new Error('Call is hold');
                }
                return [2 /*return*/, this.client.request('call_hold', {
                        id: this.id,
                        app_id: this.appId,
                    })];
            });
        });
    };
    Call.prototype.unHold = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.state !== CallActions.Hold) {
                    throw new Error('Call is active');
                }
                return [2 /*return*/, this.client.request('call_unhold', {
                        id: this.id,
                        app_id: this.appId,
                    })];
            });
        });
    };
    Call.prototype.sendDTMF = function (dtmf) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request('call_dtmf', {
                        id: this.id,
                        app_id: this.appId,
                        dtmf: dtmf,
                    })];
            });
        });
    };
    Call.prototype.blindTransfer = function (destination) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request('call_blind_transfer', {
                        id: this.id,
                        app_id: this.appId,
                        destination: destination,
                    })];
            });
        });
    };
    Call.prototype.mute = function (mute) {
        if (mute === void 0) { mute = false; }
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request('call_mute', {
                            id: this.id,
                            app_id: this.appId,
                            mute: mute,
                        })];
                    case 1:
                        res = _a.sent();
                        this._muted = mute;
                        return [2 /*return*/, res];
                }
            });
        });
    };
    Call.prototype.bridgeTo = function (call) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request('call_bridge', {
                        from_id: this.id,
                        from_app_id: this.appId,
                        to_id: call.id,
                        to_app_id: call.appId,
                    })];
            });
        });
    };
    Call.prototype.reporting = function (reporting) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.task) {
                    throw new Error("this call not in queue");
                }
                return [2 /*return*/, this.task.reporting(reporting)];
            });
        });
    };
    Call.prototype.renew = function (sec) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.task) {
                    throw new Error("this conversation not in queue");
                }
                return [2 /*return*/, this.task.renew(sec)];
            });
        });
    };
    Call.prototype.callToUser = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                req.nodeId = this.appId;
                req.parentCallId = this.id || null;
                req.sendToCallId = this.parentId || null;
                return [2 /*return*/, this.client.inviteToUser(req)];
            });
        });
    };
    return Call;
}());
export { Call };
//# sourceMappingURL=call.js.map